module.exports = __webpack_public_path__ + "static/media/4.32391b83.jpg";